import { render } from "./GroupRegist.vue?vue&type=template&id=542e359d&scoped=true"
import script from "./GroupRegist.vue?vue&type=script&lang=js"
export * from "./GroupRegist.vue?vue&type=script&lang=js"

import "./GroupRegist.vue?vue&type=style&index=0&id=542e359d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542e359d"]])

export default __exports__